export const OnboardingStatuses = {
  PREBOARDING: 'preboarding',
  ONBOARDING: 'onboarding',
  STANDARD: 'standard',
} as const;

export type OnboardingStatus =
  (typeof OnboardingStatuses)[keyof typeof OnboardingStatuses];

export const ONBOARDING_STATUSES_LIST: OnboardingStatus[] = [
  OnboardingStatuses.PREBOARDING,
  OnboardingStatuses.ONBOARDING,
  OnboardingStatuses.STANDARD,
];
